module.exports = __webpack_public_path__ + "img/logo.7d06838a.png";